import apiServiceAsync from '@/api/apiServiceAsync';

const api = await apiServiceAsync();
export default {
  setChangelogConfig() {
    return api.get('/api/v1/event-log/init').then((response) => response.data);
  },
  getChangelogList(state, params) {
    return api.get('/api/v1/event-log/logs', { params }).then((response) => response.data);
  },
  postTranslations(state, data) {
    return api.post('/api/v1/event-log/translations-hub', data).then((response) => response.data);
  },
  getFilterOptions(state, payload) {
    return api.get('/api/v1/event-log/choices', { params: { ...payload } })
      .then((response) => response.data);
  },
};
